import React, {useState} from 'react';
import {Col, Row} from "react-bootstrap";
import {DragDropContext, Draggable, Droppable} from "react-beautiful-dnd";

import {Glyphicon} from "../../../Components/Common/GlyphIcon";
import { ObjectUtils, GuidUtils} from "../../../Utils";

export const OrderableMutableList = props => {
    const dropId = GuidUtils.Generate();
    const [collapsedIds, setCollapsedIds] = useState([]);

    const sortKey = props.GetSortKey();

    const getData = () => {
        if(props.Data) {
            return props.Data.sort((a, b) => {
                return a[sortKey] - b[sortKey];
            });
        }

        return null;
    };

    const getCollapsedClassName = (sectionId) => {
        return collapsedIds.includes(sectionId) ? "pop-reorderable-collapsed" : "";
    };

    const toggleCollapsedState = (sectionId) => {

        let newCollapsedIds = collapsedIds.filter((x) => { return x !== sectionId } );

        if ( newCollapsedIds.length === collapsedIds.length ) {
            setCollapsedIds(collapsedIds.concat([sectionId]));
        } else {
            setCollapsedIds(newCollapsedIds);
        }
    };

    const onDragEnd = (result) => {
        // dropped outside the list
        if (!result.destination) {
            return;
        }

        let ret = [];
        let data = Array.from(props.Data);
        let startIndex = result.source.index;
        let endIndex = result.destination.index;
        const [removed] = data.splice(startIndex, 1);
        data.splice(endIndex, 0, removed);

        let counter = 0;
        data.forEach((x) => {
            if(x) {
                x[sortKey] = counter++;
                ret.push(x);
            }
        });

        props.UpdateItems(ret);
    };

    const getItemStyle = (isDragging, draggableStyle) => {
        return ObjectUtils.Merge(
            {
            },
            draggableStyle
        );
    };

    const getListStyle = (isDraggingOver) => {
        return {
        };
    };
    
    const data = getData();

    if (!dropId || !data) {
        return null;
    }
    
    const getItemKey = (x) => {
        let pk = props.PrimaryKeyName;
        return x[pk] || x._tempId;
    };

    const getItemTitle = (x) => {
        let pk = props.PrimaryKeyName;
        return x["name"] || (x[pk] != null ? (props.DataTypeName + " " + x[pk]) : ("New " + props.DataTypeName));
    };

    const getDraggableId = (x) => {
        return (props.PrimaryKeyName ?? 'none') + ":" + getItemKey(x);
    };
    
    const renderItems = (x, i) => {
        const itemKey = getItemKey(x);
        const itemTitle = getItemTitle(x);
        const draggableId = getDraggableId(x);

        return <Draggable
            type={dropId}
            key={itemKey}
            draggableId={draggableId}
            index={i}
        >
            {(provided, snapshot) =>
                <div
                    className={"pndlm-orderable-list-node" + (snapshot.isDragging ? " pndlm-orderable-list-node-dragging" : "")}
                    ref={provided.innerRef}
                    {...provided.draggableProps}
                    style={getItemStyle(
                        snapshot.isDragging,
                        provided.draggableProps.style
                    )}
                >
                    <Row key={itemKey}
                         className={"pop-row " + getCollapsedClassName(draggableId)}>
                        {
                            props.Editable ?
                                <Col xs={12}
                                     className="pop-remove pop-reorderable" {...provided.dragHandleProps}
                                     onClick={() => toggleCollapsedState(draggableId)}>
                                    <a className="pndlm-remove-control float-right"
                                       onClick={() => props.RemoveItem(itemKey)}>
                                        <Glyphicon glyph="remove-sign"/>
                                    </a>
                                    <a className="pndlm-drag-control float-left">
                                        <Glyphicon glyph="menu-hamburger"/>
                                    </a>
                                    <a className="pndlm-expand-control float-left">
                                        <Glyphicon glyph="chevron-down"/>
                                    </a>
                                    <a className="pndlm-collapse-control float-left">
                                        <Glyphicon glyph="chevron-up"/>
                                    </a>
                                    <a className="pop-reorderable-title">{itemTitle}</a>
                                </Col> :
                                <div {...provided.dragHandleProps} />
                        }
                        <Col xs={12} className="pop-col">
                            <props.Type
                                Key={itemKey}
                                Item={x}
                                UpdateItem={(value) => props.UpdateItem(itemKey, value)}
                                {...props.AdditionalTypeProps}
                            />
                        </Col>
                    </Row>
                </div>
            }
        </Draggable>
    }

    return (
        <DragDropContext onDragEnd={onDragEnd}>
            <Droppable droppableId={dropId} type={dropId}>
                {(provided, snapshot) =>
                    <div
                      ref={provided.innerRef}
                      style={getListStyle(snapshot.isDraggingOver)}
                      className={"pndlm-orderable-list-container" + (snapshot.isDraggingOver ? " pndlm-orderable-list-container-dragging-over" : "")}
                    >
                        { data && data.map(renderItems) }
                        {provided.placeholder}
                    </div>
                }
            </Droppable>
            {
                props.Editable ?
                    <Row>
                        <Col xs={12}>
                            <a className="add-table float-right" onClick={() => props.AddItem()}>
                                <Glyphicon glyph="plus-sign" />Add {props.DataTypeName}
                            </a>
                        </Col>
                    </Row> :
                    null
            }
        </DragDropContext>
    );
};



